// export const BASE_API = "http://localhost:4000";
export const BASE_API = "https://componenteb-v1-0-0.onrender.com";

// Exportar colores
// $color-blanco: #F2F2F2;
// $color-azul: #13304D;
// $color-naranja: #EE7511;

// $color-verde: #5F6D36;
// $color-turquesa: #085D60;
// $color-violeta: #542141;
// $color-violeta-75: rgba(84, 33, 65, 0.75);
// $color-azul-75: rgba(19, 48, 77, 0.75);

// $color-primario: $color-violeta;
// $color-primario-hover: $color-violeta-75;

// $color-fondo: $color-blanco;
export const color_blanco_puro = "#FFFFFF";
export const color_blanco = "#F2F2F2";
export const color_azul = "#13304D";
export const color_naranja = "#EE7511";

export const color_verde = "#5F6D36";
export const color_turquesa = "#085D60";
export const color_violeta = "#542141";

export const color_violeta_75 = "rgba(84, 33, 65, 0.75)";
export const color_azul_75 = "rgba(19, 48, 77, 0.75)";

export const color_primario = color_violeta;
export const color_primario_hover = color_violeta_75;
export const color_fondo = color_blanco;
